import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import API from "../../middleware/Api";
import Auth from "../../middleware/Auth";
import { useLocation } from "react-router";
import { setSessionStatus } from "../../redux/explorer";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function LoginOAuth() {
    const dispatch = useDispatch();
    const SetSessionStatus = useCallback(
        (status) => dispatch(setSessionStatus(status)),
        [dispatch]
    );

    const history = useHistory();
    const location = useLocation();
    const query = useQuery();
    const oauthError = query.get("oauth_error");

    useEffect(() => {
        localStorage.removeItem("siteConfigCache");

        if (oauthError) {
            history.push("/login");
            return;
        }

        // 后端已在回调中写入会话，前端直接拉取当前登录用户，
        // 不在 URL 中传递任何敏感数据
        API.get("/user/me")
            .then((resp) => {
                Auth.authenticate(resp.data);
                SetSessionStatus(true);
                history.push("/home");
            })
            .catch(() => {
                history.push("/login");
            });
    }, [location]);

    return (<></>);
}

export default LoginOAuth;
